import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Banner, BannerPlacement } from '@monorepo/types';
import { useStore } from '../../../../../helpers/use-store';
import { BannerItem, PromotionalBannersLayout } from './components';

export const PromotionalBanners: FC = observer(() => {
  const {
    dataStore: { applicationConfigStore },
  } = useStore();

  const { banners } = applicationConfigStore.applicationConfig;

  if (!banners || banners.length === 0) {
    return null;
  }

  const leftBanner = banners.find(
    (banner: Banner) =>
      banner.placement === BannerPlacement.AccountDashboardLeft,
  );

  const rightBanner = banners.find(
    (banner: Banner) =>
      banner.placement === BannerPlacement.AccountDashboardRight,
  );

  // Only render if at least one banner exists
  if (!leftBanner && !rightBanner) {
    return null;
  }

  // Collect only the banners that actually exist
  const bannersToRender: React.ReactElement[] = [];

  if (leftBanner) {
    bannersToRender.push(
      <BannerItem key={`left-${leftBanner.name}`} banner={leftBanner} />,
    );
  }

  if (rightBanner) {
    bannersToRender.push(
      <BannerItem key={`right-${rightBanner.name}`} banner={rightBanner} />,
    );
  }

  return <PromotionalBannersLayout>{bannersToRender}</PromotionalBannersLayout>;
});
